<!-- Back Button -->
<div class="container">
  <div class="text-white pt-3 cursor-pointer d-none d-lg-block" (click)="goBack()">
    <span class="material-icons align-middle fw-bold pe-2">navigate_before</span>
    <span class="font-size-14 fw-bold">{{ 'rewards.back.link' | translate }} </span>
  </div>
</div>

<!-- Points Summary -->
<div class="px-2">
  <fgb-points-summary-bar
    [backButtonLink]="marketplaceItemType.backLink"
    [marketplaceItemGroup]="marketplaceItemType.group"
  ></fgb-points-summary-bar>
</div>

<fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>
